import React from "react";
import './Spinner.css';

const SpinnerCircles = ({red}) => (
  <div className={red ?"spinner circlesRed" :'spinner circles'}>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
);

export default SpinnerCircles;
